import { Content, Root, Trigger } from './tooltip';
import { IconTrigger, TextTrigger } from './trigger';

export { Arrow } from './arrow';

/**
 * Tooltip component for displaying contextual information on hover or click.
 * On desktop, shows a floating tooltip on hover. On mobile, opens a bottom sheet modal.
 *
 * @example
 * <Tooltip.Root placement="bottom">
 *   <Tooltip.Trigger>
 *     <InformationCircleIcon size={16} />
 *   </Tooltip.Trigger>
 *   <Tooltip.Content bottomSheetTitle="Title for mobile">
 *     This is helpful information
 *   </Tooltip.Content>
 * </Tooltip.Root>
 *
 * @example
 * // Using asChild to apply tooltip to existing button
 * <Tooltip.Root placement="bottom">
 *   <Tooltip.Trigger asChild>
 *     <Button label="Hover me" />
 *   </Tooltip.Trigger>
 *   <Tooltip.Content>
 *     Button tooltip content
 *   </Tooltip.Content>
 * </Tooltip.Root>
 */
export const Tooltip = {
  Root,
  Trigger,
  IconTrigger,
  TextTrigger,
  Content,
};
